export default "__VITE_ASSET__DKn4JsCJ__"